import { useLegalEntityFilter } from './legalEntity'
import { useTeamFilter } from './team'
import { useWorkplaceFilter } from './workplace'

export const useEmployeeFilters = () => {
  const workplaceFilter = useWorkplaceFilter()
  const teamFilter = useTeamFilter()
  const legalEntityFilter = useLegalEntityFilter()

  return {
    workplace: workplaceFilter,
    team: teamFilter,
    legalEntity: legalEntityFilter,
  }
}

export type UseEmployeeFiltersResult = ReturnType<typeof useEmployeeFilters>
